import React, { useState } from 'react'
import BotonCheckAtri from './listadoAtributos/BotonCheckAtri'
import { NumericFormat } from 'react-number-format';

const ListadoAtributos = ({ lista, atributosTerminados, setAtributosTerminados, categoria }) => {

	let { nombre, opciones } = lista

	//Suma en atributos definitivos solo para el check.
	const onClickCheck = (index, atributo, categoria) => e => {
		setAtributosTerminados([{ atributo, activo: true, categoria, precio: atributo.precio, inventario: atributo.cantidad, cantidad: 1, tipo: categoria, opcion: atributo.opcion }])
	}


	const onClickResta = (index, atributo) => e => {

		//Busca si el atributo existe, si existe y es menor a 1
		//lo elimina y si exite y es mayor a 1 lo resta
		if (atributosTerminados.find(item => item.atributo === atributo)) {

			let newArr = []
			atributosTerminados.map((item, i) => {
				if (item.atributo === atributo) {
					if (item.cantidad > 1) {
						let resta = item.cantidad - 1
						newArr.push({ ...item, cantidad: resta, atributo: atributo, activo: false })
					}
					else {
						setAtributosTerminados(atributosTerminados => atributosTerminados.filter((atributo, cont) => cont !== atributo));
					}
				} else { newArr.push(item); }
			});
			setAtributosTerminados(newArr);
		}
	}

	//Para saber si debe mostrar el input de tipo botones suma y resta o un check
	// compara si el atributo es unico o no
	const revisaCheck = atributo => {

		let resultado = false
		if (atributosTerminados.find(item => item.atributo === atributo)) {
			atributosTerminados.map((item, i) => {
				if (item.atributo === atributo) {
					resultado = item.activo
				}
			})
		}
		return resultado
	}

	return (
		<div>

			<React.Fragment>
				<h4 className="tituloAtributo">
					{nombre}
				</h4>

				<div className="col-12 infoCardPedido btn_cat_atributo">
					{opciones.map((atributo, index) => {
						return (
							<React.Fragment key={index}>
								{atributo != "" ?
									<div className="row cont_Atributos col-md-12 mb-2">
										<div className="col-md-9 col-9 d-flex  flex-column justify-content-center">
											<p className='pt-0'>{atributo.opcion}</p>
											<div className='d-flex descripcion-opciones'>
												{atributo.cantidad ? <span className='pt-0'>Cantidad Disponible: {atributo.cantidad}</span> : null}
												<span className='pt-0'>Precio: <NumericFormat className='m-0' thousandSeparator prefix='$' displayType="text" value={atributo.precio} /> </span>
											</div>

										</div>

										<div className="col-md-3 col-3 ">
											<BotonCheckAtri
												index={index}
												atributo={atributo}
												categoria={categoria}
												onClickSuma={onClickCheck}
												onClickResta={onClickResta}
												activo={revisaCheck(atributo)}
											/>
										</div>


									</div>
									: null}
							</React.Fragment>
						)
					}

					)}
				</div><br />


			</React.Fragment>




		</div>);


}


export default ListadoAtributos